export default __webpack_public_path__ + "e70daf6b10577667bc685986bcdeadb8.svg";